import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["xlink:href"]
const _hoisted_2 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    focusable: "false",
    class: _normalizeClass(_ctx.alleCssKlassen),
    style: _normalizeStyle(_ctx.cssStyle),
    "aria-hidden": "true"
  }, [
    _createElementVNode("use", {
      class: _normalizeClass({ 'c-collapse__icon--up': _ctx.istCollapseElement }),
      "xlink:href": _ctx.iconPfad(_ctx.props.iconName)
    }, null, 10, _hoisted_1),
    (_ctx.istCollapseElement)
      ? (_openBlock(), _createElementBlock("use", {
          key: 0,
          class: _normalizeClass({ 'c-collapse__icon--down': _ctx.istCollapseElement }),
          "xlink:href": _ctx.iconPfad('icon-arrow-down')
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true)
  ], 6))
}